import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getPlantillasCobranza } from '../../helpers/api_helper';

const useObtenerPlantillas = (refresh = 0) => {
    const [plantillas, setPlantillas] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);

    useEffect(() => {
        const fetchPlantillas = async () => {
            if (!tenantId || !empresa) return;

            setLoading(true);
            setError(null);
            try {
                const response = await getPlantillasCobranza({
                    tenantId, empresa
                });
                setPlantillas(response);
            } catch (err) {
                const errorMessage = `Failed to fetch plantillas: ${err.message || 'Unknown error'}`;
                setError(errorMessage);
                console.error(errorMessage);
                setPlantillas(null);
            } finally {
                setLoading(false);
            }
        };

        fetchPlantillas();
    }, [tenantId, empresa, refresh]);

    return { plantillas, loading, error };
};

export default useObtenerPlantillas;